import { BASE_TIPPY_DIRECTIONS as e, TIPPY_STICKY_VALUES as t } from "./tippy-utils.js";
//#region components/popover/popover_constants.js
var n = {
	none: void 0,
	small: "d-p4",
	medium: "d-p8",
	large: "d-p16"
}, r = {
	none: void 0,
	small: "d-pl4",
	medium: "d-pl8",
	large: "d-pl16"
}, i = [
	"dialog",
	"menu",
	"listbox",
	"tree",
	"grid"
], a = [
	"clippingParents",
	"viewport",
	"document"
], o = ["", "anchor"], s = [
	"none",
	"dialog",
	"first"
], c = [
	"parent",
	"body",
	"root"
], l = [...t], u = [...e], d = {
	POPOVER_PADDING_CLASSES: n,
	POPOVER_HEADER_FOOTER_PADDING_CLASSES: r,
	POPOVER_ROLES: i,
	POPOVER_BOUNDARY_VALUES: a,
	POPOVER_CONTENT_WIDTHS: o,
	POPOVER_INITIAL_FOCUS_STRINGS: s,
	POPOVER_APPEND_TO_VALUES: c,
	POPOVER_STICKY_VALUES: l,
	POPOVER_DIRECTIONS: u
};
//#endregion
export { c as POPOVER_APPEND_TO_VALUES, a as POPOVER_BOUNDARY_VALUES, o as POPOVER_CONTENT_WIDTHS, u as POPOVER_DIRECTIONS, r as POPOVER_HEADER_FOOTER_PADDING_CLASSES, s as POPOVER_INITIAL_FOCUS_STRINGS, n as POPOVER_PADDING_CLASSES, i as POPOVER_ROLES, l as POPOVER_STICKY_VALUES, d as default };

//# sourceMappingURL=popover-constants.js.map